// FOOTER COLLAPSIBLE
function initializeCollapsibleFooter() {
  if (window.matchMedia("(min-width: 750px)").matches) {
    return;
  }

  const handleCollapse = (heading) => {
    if (heading.classList.contains("block-collapsed")) {
      heading.classList.remove("block-collapsed");
      heading.setAttribute("aria-expanded", "true");
    } else {
      heading.classList.add("block-collapsed");
      heading.setAttribute("aria-expanded", "false");
    }
  };

  document
    .querySelectorAll(".grid .footer-block__heading")
    .forEach((heading, index) => {
      if (!heading.hasAttribute("data-collapsible-initialized")) {
        heading.classList.add("block-collapsed");
        heading.setAttribute("role", "button");
        heading.setAttribute("aria-expanded", "false");
        heading.setAttribute("tabindex", "0");
        heading.nextElementSibling.setAttribute(
          "id",
          `footer-block-index-${index}`
        );
        heading.setAttribute("aria-controls", `footer-block-index-${index}`);
        heading.addEventListener("click", () => {
          handleCollapse(heading);
        });
        heading.addEventListener("keypress", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            handleCollapse(heading);
            event.preventDefault();
          }
        });
        heading.setAttribute("data-collapsible-initialized", "true");
      }
    });
}

// Run on initial page load
document.addEventListener("DOMContentLoaded", initializeCollapsibleFooter);

// Set up MutationObserver to watch for changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      initializeCollapsibleFooter();
    }
  });
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });

// Reapply on window resize
window.addEventListener("resize", initializeCollapsibleFooter);

// HEADER MENU HOVER
const headerWrapper = document.querySelector(".header-wrapper");
const items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    items.forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });
    item.setAttribute("open", true);
  });
});

document.addEventListener("mouseover", (event) => {
  if (
    !headerWrapper.contains(event.target) &&
    !event.target.closest(".mega-menu__content")
  ) {
    items.forEach((item) => {
      item.removeAttribute("open");
    });
  }
});

// MEGA MENU

document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".collapse-toggle");

  toggleButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const expanded = this.getAttribute("aria-expanded") === "true" || false;
      this.setAttribute("aria-expanded", !expanded);
      this.textContent = expanded ? "+" : "-";

      const target = document.getElementById(
        this.getAttribute("aria-controls")
      );
      target.classList.toggle("collapsed");
    });
  });
});
